<mat-card class="power-user-mode-card">
  <mat-card-header>
    <div class="header-content">
      <mat-icon class="header-icon">science</mat-icon>
      <div class="header-text">
        <mat-card-title>Power User Mode</mat-card-title>
        <mat-card-subtitle>Enable advanced diagnostic and analysis features for this project</mat-card-subtitle>
      </div>
    </div>
  </mat-card-header>

  @if (saving) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  }

  <mat-card-content>
    @if (error) {
      <div class="error-message">{{ error }}</div>
    }

    <div class="setting-row">
      <div class="setting-info">
        <span class="setting-name">Enable Power User Mode</span>
        <span class="setting-description">
          Shows advanced features: region hierarchy sub-items in the table of contents, cross-reference graph on the
          References tab, and detailed ingestion diagnostics. Intended for advanced users and developers.
        </span>
      </div>
      <mat-slide-toggle [checked]="enabled" [disabled]="saving" (change)="onToggle($event.checked)"></mat-slide-toggle>
    </div>

    @if (enabled) {
      <div class="setting-row buffer-row">
        <div class="setting-info">
          <span class="setting-name">Highlight Feather (%)</span>
          <span class="setting-description">
            Controls the soft edge around bounding box highlights on the preview tab, as a percentage of the highlighted
            box's size. Because it scales with the box, the halo looks the same at every zoom level. Larger values
            produce a wider gradient transition; 0% gives a hard edge.
          </span>
        </div>
        <div class="slider-area">
          <mat-slider
            [min]="minFeatherPct"
            [max]="maxFeatherPct"
            [step]="featherPctStep"
            discrete
            [displayWith]="formatFeatherLabel"
          >
            <input
              matSliderThumb
              aria-label="Highlight feather percentage"
              [ngModel]="highlightFeatherPct"
              (ngModelChange)="onHighlightFeatherChange($event)"
            />
          </mat-slider>
          <span class="slider-value">{{ highlightFeatherPct }}%</span>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
